import { getConfig } from './utils';
export const get = async (url) => {
  url = `${getConfig().baseApi}/${url}`;

  const request = await fetch(url);

  const response = await request.json();
  if (response?.error) throw response.error;

  return response;
};

export const post = async (url, body) => {
  url = `${getConfig().baseApi}/${url}`;
  body = JSON.stringify(body);

  const request = await fetch(url, {
    method: 'POST',
    body: body,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const response = await request.json();
  if (response?.error) throw response.error;

  return response;
};

export const put = async (url, body) => {
  url = `${getConfig().baseApi}/${url}`;
  body = JSON.stringify(body);

  const request = await fetch(url, {
    method: 'PUT',
    body: body,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const response = await request.json();
  if (response?.error) throw response.error;

  return response;
};
